<template>
  <v-container fluid>
    <div v-if="!articles.length" class="ma-12">
      <v-alert prominent type="error">
        <v-row align="center">
          <v-col class="grow"> No product similar </v-col>
        </v-row>
      </v-alert>
    </div>
    <v-row class="scroll">
      <v-col
        v-for="(item, index) in this.articles"
        :key="index"
        cols="6"
        md="3"
      >
        <v-img
          :src="
            item.picture_url ||
            'https://skotfashion.com/wp-content/uploads/2018/02/placeholder.jpg'
          "
          :lazy-src="
            item.picture_url ||
            'https://skotfashion.com/wp-content/uploads/2018/02/placeholder.jpg'
          "
          :aspect-ratio="1"
        ></v-img>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: "product_match",
  data() {
    return {
      articles: [],
      RequestDetails: {},
    };
  },
  props: {
    similarity: {},
  },
  mounted() {
    this.articles =
      this.similarity && this.similarity[4]
        ? this.similarity[4]["similar products"]
        : [];
    this.RequestDetails =
      this.similarity && this.similarity[1]
        ? this.similarity[1]["Request Details"]
        : {};
    // console.log(this.articles, this.RequestDetails, this.articles.length);
  },
};
</script>
